<template>
<div>
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">

      <div class="sp_button_area" v-if="code_reader_flg" style="text-align:center;
        flex-direction: row;justify-content: center;">
        <div v-if="checkin_flg==true">
          <button class="btn btn-primary mx-aut" 
            style="font-size: 13.5px;width: 200px; height: 40px;margin:15px 5px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" 
            v-on:click="codereader()">二次元コード読取
          </button>
        </div>
      </div><br>

      <div v-on:click="Smart_logout" style="align-items: center;"><u>ログアウト</u></div>

    </span>
    <div class="p-2 " style="margin-top:0;background-color:white">

    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
     <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>
<!--
    <div v-if="midoku_count!=0" class="pc_only" style="color:red;cursor: pointer;" :onclick="move_notification">
      <u>
        未読のお知らせが {{midoku_count}} 件あります。
      </u>
     </div>
-->
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area">

      <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
      <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>

    <br clear="all">
    <div class="sp_only" style="text-align:center;padding: 5px;text-align: left;font-size: 0.9rem;">
      <span style="color:red">プログラム番号：名称をタップしてください。</span><br>
      （<span style="color:#4169e1">青枠下線部</span>）
     </div>
    <!-- PC時は全件数、ページ選択、表示件数を表示 -->
  <div class="pg_list_page" style="padding: 0 5px;">

    <div style="width:25%">
      <span style="display:flex;align-items: center;"><b style="font-size: 20px;padding-right: 5px">{{ kensu }}</b> 件見つかりました</span>
    </div>

    <div style="width:50%;display: flex;justify-content: center;align-items: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div>
    
    <div style="width:25%;display: flex;align-items: center;justify-content: flex-end;">
      
      <span style="display:flex;float: right;">
        表示件数：
        <select v-model="gyo_count" v-on:change="gyo_change">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
        </select>
      </span>
    </div>
  </div>

    
  <!--スマホ時は件数のみ表示-->
  <div class="sp_only" style="width:100%;padding-left:5px;">
      <span style="display:flex;align-items: center;">検索結果 <b style="padding:0 10px">{{ kensu }}</b> 件</span>
  </div>

    <!-- 体験プログラム概要 -->
    <div align="left" v-for="(pg,i) in program.slice(st-1,ed)" v-bind:key="pg.id">
    <div v-bind:class="{'hov':over(i) == false,'hov_over':over(i) == true}" style="padding:4px;margin-bottom: 12px;">
    <table border="1" rules="all"  style="width:100%;border-collapse:collapse;cursor:pointer">
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)">
                  <td style="font-size:14px;background-color:white;display:flex;align-items: center;justify-content: space-between;">
                    <div style="float:left"><b>{{pg.bunrui1 }}</b><br>
                    <span v-if="list_disp[1] == 1"> {{pg.bunrui2 }} </span>
                    </div>
<!--
                    <div v-if="pg.teiin_flg == 1" style="float:right">
                      
                    <img  src="../../images/max2.png" alt="満員御礼" style="height:45px" />
                    </div>-->
                  </td>
                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)"><td style="padding:2pt 6pt;background-color:royalblue;color:white;border-bottom: 1px solid #FFF;display: flex;justify-content: flex-start;align-items: center;">
                  <div style="font-size:20px;"><u>{{ pg.taiken_no_text }}：{{pg.name }}</u></div>
                </td></tr>
                <template v-if="sub[i + ((current_page -1 ) * gyo_count)]">
                  <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="sub[i + ((current_page -1 ) * gyo_count)].length != 0">
                    <td style="font-size:16px;padding:5pt;background-color:linen;" border="1">
                      <b>【活動1】</b>
                    </td>
                  </tr>
                </template>

                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[9] == 1 && pg.k_name != '' && pg.k_name != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">開催地名</b>
                      <b class="sp_only midashi_sp">開催地名</b>
                      <div class="program_naiyo">{{pg.k_name}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[3] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">施設住所</b>
                      <b class="sp_only midashi_sp">施設住所</b>
                      <div class="program_naiyo">{{pg.k_jusyo}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[11] == 1 && pg.k_access != '' && pg.k_access != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">アクセス方法</b>
                      <b class="sp_only midashi_sp">アクセス方法</b>
                      <div class="program_naiyo">{{pg.k_access}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[10] == 1 && pg.k_tel != '' && pg.k_tel != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">連絡先</b>
                      <b class="sp_only midashi_sp">連絡先</b>
                      <div class="program_naiyo">{{pg.k_tel}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[4] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      
                      <b class="pc_only midashi_pc">活動内容</b>
                      <b class="sp_only midashi_sp">活動内容</b>
                      <div class="program_naiyo" style="white-space: pre-wrap;">{{pg.naiyou}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="pg.teiin_settei == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      
                      <b class="pc_only midashi_pc">定員</b>
                      <b class="sp_only midashi_sp">定員</b>
                      <div class="program_naiyo">
                        
                          <template v-if="pg.teiin_mongon != '' || pg.teiin_mongon != null">
                              {{ pg.teiin_mongon }}
                          </template>
                          <template v-else>
                            
                            <template v-if="pg.teiin_oneday >= 999">
                                制限なし
                              </template>
                             <template v-else>
                              {{ pg.teiin_oneday }}&nbsp;名まで&nbsp;
                              </template>
                              
                          </template>
                      </div>
                    </div>
                  </td>

                </tr>
                
                <template v-for="(result,i2) in nittei[i + ((current_page -1 ) * gyo_count)]" v-bind:key="i2">
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[5] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      <span v-if="i2 != 0"></span>
                      
                        <template v-if="pg.shubetsu == 1">

                          <template  v-if="nittei[i + ((current_page -1 ) * gyo_count)].length == 1">
                            <b class="pc_only midashi_pc">日程</b>
                            <b class="sp_only midashi_sp">日程</b>
                          </template>
                          <template v-else>
                            <b class="pc_only midashi_pc">日程{{ (i2+1) }}</b>
                            <b class="sp_only midashi_sp">日程{{ (i2+1) }}</b>

                          </template>
                            <div class="program_naiyo">
                              
                              <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>
                              <span v-for="(jikantai,j) in result.jikantai_list" v-bind:key="j">
                                
                                    <hr style="margin:1px 0" v-if="result.jikantai_list.length > 1">
                                    <div style="display: flex;align-items: center;flex-direction: row;">
                                      
                                      <b>時間帯<template v-if="result.jikantai_list.length > 1">{{j+1}}</template>：</b>
                                      <div>
                                        <span v-if="jikantai.jikantai_start">{{TimeSetting(jikantai.jikantai_start)}} ～ {{TimeSetting(jikantai.jikantai_end)}}</span>
                                        <template v-if="pg.teiin_settei == 0">
                                          <br>
                                          <b  style="margin-right:5px">定員</b>
                                          <template v-if="jikantai.teiin_mongon != '' && jikantai.teiin_mongon != null">
                                            {{jikantai.teiin_mongon}}
                                          </template>
                                          <template v-else>
                                            <span v-if="jikantai.teiin >= 999">無し</span><span v-else-if="result.teiin">{{jikantai.teiin}} 名まで</span>
                                          </template>
                                        </template>
                                    </div>
                                  </div>
                                  
                                    <template v-if="result.jikantai_list.length > 1 && (result.kaisai_youbi != null || result.jogai != null || result.jogai_date != null || result.comment != null)">
                                      <hr style="margin:1px 0" v-if="(j == result.jikantai_list.length - 1) ">
                                    </template>
                                  </span>
                              <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                              <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                              <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                              <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                            </div>
                        </template>
                        <template v-else>
                              
                            <b class="pc_only midashi_pc">開催期間</b>
                            <b class="sp_only midashi_sp">開催期間</b>
                            <div class="program_naiyo">
                              {{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                            </div>
                        </template>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="pg.bikou !='' && pg.bikou != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center">
                      
                      <b class="pc_only midashi_pc">特記事項</b>
                      <b class="sp_only midashi_sp">特記事項</b>
                      <div class="program_naiyo" style="color:red;white-space: pre-wrap;">{{pg.bikou}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="pg.shubetsu==1 && list_disp[6] == 1 && pg.nittei_sentaku == 0">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    
                      
                      <div style="display: flex;align-items: center;">
                        <template  v-if="(pg.nissu_min != '' || pg.nissu_min != null ) && (pg.nissu_max != '' || pg.nissu_max != null ) ">
                        <b class="pc_only midashi_pc">活動日数</b>
                        <b class="sp_only midashi_sp">活動日数</b>
                        <div class="program_naiyo">
                          
                           <template v-if="pg.nissu_mongon != '' && pg.nissu_mongon != null">
                            
                                {{pg.nissu_mongon}}
                              </template>
                              <template v-else>
                              <span v-if=" pg.nissu_min == pg.nissu_max ">
                                {{ pg.nissu_min  }}日
                              </span>
                              <span v-else-if="pg.nissu_min != pg.nissu_max ">
                                <span v-if="pg.nissu_max == '' || pg.nissu_max == null ">
                                  {{ pg.nissu_min  }}日以上
                                </span>
                                <span v-else-if="pg.nissu_min == '' || pg.nissu_min == null ">
                                  {{ pg.nissu_max  }}日以下
                                </span>
                                <span v-else>
                                  {{pg.nissu_min}} ～ {{pg.nissu_max}}日
                                </span>
                                </span>&nbsp;&nbsp;
                                <span v-if="pg.nissu_joken == 1">連続</span>
                            </template>
                        </div>
                      </template>
                      </div>

                    </td>

                  </tr>
                  <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[7] == 1">
                    <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                      <div style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">参加条件</b>
                      <b class="sp_only midashi_sp">参加条件</b>
                      <div class="program_naiyo">
                        
                         <template v-if="pg.joken_mongon != '' && pg.joken_mongon != null">
                            {{pg.joken_mongon }}
                         </template>
                         <template v-else>
                            {{createJokenText(pg.joken_all_start,pg.joken_all_end)}}
                         </template>
                      </div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[8] == 1">
                  
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    
                    <div style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">申込〆切</b>
                      <b class="sp_only midashi_sp">申込〆切</b>
                      <div class="program_naiyo">
                        
                        <!--
                        〆切日パターン
                        1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                        2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                        3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                        -->
                        <template v-if="end_shubetsu == 1">
                          {{DateTimeSetting(end_datetime)}}
                        </template>
                        <template v-else-if="pg.shimekiri_date">{{EuDateTimeSetting(pg.shimekiri_date)}}</template>
                        <template v-else>開催日の{{pg.shimekiri_nissu}}日前まで申込可能</template>
                        
                      </div>
                    </div>
                  </td>
              
                </tr>

                <template v-if="sub[i + ((current_page -1 ) * gyo_count)]">
                <template v-if="sub[i + ((current_page -1 ) * gyo_count)].length != 0">
                  <!-- サブプログラムがある場合 -->
                  <template v-for="(spg,s) in sub[i + ((current_page -1 ) * gyo_count)]" v-bind:key="s">
                    <hr style="margin:0">
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" >
                      <td style="font-size:16px;padding:5pt;background-color:linen;" border="1">
                        <b>【活動{{s+2}}】</b>
                      </td>
                    </tr>

                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[9] == 1 && spg.k_name != '' && spg.k_name != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">開催地名</b>
                          <b class="sp_only midashi_sp">開催地名</b>
                          <div class="program_naiyo">{{spg.k_name}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[3] == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">施設住所</b>
                          <b class="sp_only midashi_sp">施設住所</b>
                          <div class="program_naiyo">{{spg.k_jusyo}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[11] == 1 && spg.k_access != '' && spg.k_access != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">アクセス方法</b>
                          <b class="sp_only midashi_sp">アクセス方法</b>
                          <div class="program_naiyo">{{spg.k_access}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[10] == 1 && spg.k_tel != '' && spg.k_tel != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">連絡先</b>
                          <b class="sp_only midashi_sp">連絡先</b>
                          <div class="program_naiyo">{{spg.k_tel}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[4] == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">活動内容</b>
                          <b class="sp_only midashi_sp">活動内容</b>
                          <div class="program_naiyo" style="white-space: pre-wrap;">{{spg.naiyou}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="spg.teiin_settei == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">定員</b>
                          <b class="sp_only midashi_sp">定員</b>
                          <div class="program_naiyo">
                            
                            <template v-if="spg.teiin_mongon != '' || spg.teiin_mongon != null">
                                {{ spg.teiin_mongon }}
                            </template>
                            <template v-else>
                              
                              <template v-if="spg.teiin_oneday >= 999">
                                制限なし
                              </template>
                               <template v-else>
                              {{ spg.teiin_oneday }}&nbsp;名まで&nbsp;
                              </template>
                            </template>
                          </div>
                        </div>
                      </td>

                    </tr>
                    
                    <template v-for="(sub_array,s2) in sub_nittei[i + ((current_page -1 ) * gyo_count)]" v-bind:key="s2">
                      <template v-for="(result,i2) in sub_array" v-bind:key="i2">
                        <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[5] == 1 && ( spg.taiken_id == result.taiken_id)">
                          <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                            <div style="display: flex;align-items: center;">
                              <span v-if="i2 != 0"></span>
                                <template v-if="pg.shubetsu == 1">

                                  <template  v-if="sub_array.length == 1">
                                    <b class="pc_only midashi_pc">日程</b>
                                    <b class="sp_only midashi_sp">日程</b>
                                  </template>
                                  <template v-else>
                                    <b class="pc_only midashi_pc">日程{{ (i2+1) }}</b>
                                    <b class="sp_only midashi_sp">日程{{ (i2+1) }}</b>

                                  </template>
                                    <div class="program_naiyo">
                                      
                                      <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                                      <span v-for="(jikantai,j) in result.jikantai_list" v-bind:key="j">
                                    <hr style="margin:1px 0" v-if="result.jikantai_list.length > 1">
                                            <div style="display: flex;align-items: center;flex-direction: row;">
                                              <div>
                                                <b>時間帯<template v-if="result.jikantai_list.length > 1">{{j+1}}</template>：</b>
                                                  <span v-if="jikantai.jikantai_start">{{TimeSetting(jikantai.jikantai_start)}} ～ {{TimeSetting(jikantai.jikantai_end)}}</span>
                                                  <template v-if="spg.teiin_settei == 0">
                                                    <br>
                                                    <b  style="margin-right:5px">定員</b>
                                                    <template v-if="jikantai.teiin_mongon != '' && jikantai.teiin_mongon != null">
                                                      {{jikantai.teiin_mongon}}
                                                    </template>
                                                    <template v-else>
                                                      <span v-if="jikantai.teiin >= 999">無し</span><span v-else-if="result.teiin">{{jikantai.teiin}} 名まで</span>
                                                    </template>
                                                  </template>
                                              </div>
                                            </div>
                                            
                                    <template v-if="result.jikantai_list.length > 1 && (result.kaisai_youbi != null || result.jogai != null || result.jogai_date != null || result.comment != null)">
                                      <hr style="margin:1px 0" v-if="(j == result.jikantai_list.length - 1) ">
                                    </template>
                                          </span>
                                      <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                                      <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                                      <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                                      <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                      
                                    <b class="pc_only midashi_pc">開催期間</b>
                                    <b class="sp_only midashi_sp">開催期間</b>
                                    <div class="program_naiyo">
                                      {{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                                    </div>
                                </template>
                            </div>
                          </td>
                        </tr>
                    </template>
                  </template>
                  <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="spg.bikou !='' && spg.bikou != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">特記事項</b>
                          <b class="sp_only midashi_sp">特記事項</b>
                          <div class="program_naiyo" style="color:red;white-space: pre-wrap;">{{spg.bikou}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="pg.shubetsu==1 && list_disp[6] == 1 && spg.nittei_sentaku == 0">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        
                          
                          <div style="display: flex;align-items: center;">
                            <template  v-if="(spg.nissu_min != '' || spg.nissu_min != null ) && (spg.nissu_max != '' || spg.nissu_max != null ) ">
                            <b class="pc_only midashi_pc">活動日数</b>
                            <b class="sp_only midashi_sp">活動日数</b>
                            <div class="program_naiyo">
                              
                              <template v-if="spg.nissu_mongon != '' && spg.nissu_mongon != null">
                                {{spg.nissu_mongon}}
                              </template>
                              <template v-else>
                              <span v-if=" spg.nissu_min == spg.nissu_max ">
                              {{ spg.nissu_min  }}日
                            </span>
                            <span v-else-if="spg.nissu_min != spg.nissu_max ">
                              <span v-if="pg.nissu_max == '' || spg.nissu_max == null ">
                                {{ spg.nissu_min  }}日以上
                              </span>
                              <span v-else-if="spg.nissu_min == '' || spg.nissu_min == null ">
                                {{ spg.nissu_max  }}日以下
                              </span>
                              <span v-else>
                                {{ spg.nissu_min }} ～ {{ spg.nissu_max }}日
                              </span>
                              </span>&nbsp;&nbsp;
                              <span v-if="spg.nissu_joken == 1">連続</span>
                              </template>
                            </div>
                          </template>
                          </div>

                        </td>

                      </tr>
                      <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[7] == 1">
                        <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                          <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">参加条件</b>
                          <b class="sp_only midashi_sp">参加条件</b>
                          <div class="program_naiyo">
                            
                            <template v-if="spg.joken_mongon != '' && spg.joken_mongon != null">
                                {{spg.joken_mongon }}
                            </template>
                            <template v-else>
                                {{createJokenText(spg.joken_all_start,spg.joken_all_end)}}
                            </template>
                          </div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(pg.taiken_id,pg.teiin_flg)" v-if="list_disp[8] == 1">
                      
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        
                        <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">申込〆切</b>
                          <b class="sp_only midashi_sp">申込〆切</b>
                          <div class="program_naiyo">
                            
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                            -->
                            <template v-if="end_shubetsu == 1">
                              {{DateTimeSetting(end_datetime)}}
                            </template>
                            <template v-else-if="spg.shimekiri_date">{{EuDateTimeSetting(spg.shimekiri_date)}}</template>
                            <template v-else>開催日の{{spg.shimekiri_nissu}}日前まで申込可能</template>
                            
                          </div>
                        </div>
                      </td>
                  
                    </tr>
                  </template>

                  
                </template>
                </template>
              </table>
    </div>
    </div><br/>
    
    <div class="pg_list_page" style="width:100%;justify-content: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div><br/>
  </div>

  <!--フッター-->
  <FooterArea v-on:call="call"/>
  <!--メッセージを表示するモーダルウィンドウ-->
  <component v-bind:is="contentMessage"
            v-bind:message_text="message"
            v-bind:message_cat="message_cat"
            v-bind:message_flag="message_flag"
            @close_message="Close_message"
            @ok_message="OK_message"/>

</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { DateSetting,DateTimeSetting,TimeSetting,ShimekiriSetting,EuDateTimeSetting,youbi_irekae,GlobalData,logout } from '../js/userdata_shisetsu.js'

import axios from 'axios'
import { ref, computed, watch } from 'vue';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

import { useStore } from 'vuex'
const store = useStore()
let current_page = ref(store.state.current_page)
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

const prop = defineProps(['param'])
let program = prop.param.program
let nittei = prop.param.nittei
let sub = prop.param.sub
let sub_nittei = prop.param.sub_nittei

// 二次元コードの表示・非表示（申込0の時は非表示にする）
let code_reader_flg = ref(false)
if(program.length != 0){
  code_reader_flg.value = true
}

// チェックイン機能の利用フラグ
let checkin_flg = ref(false)

let disp_nittei = ref([])

//const cityname = prop.param.cityname
const cityname = route.params.shakyo
const facility = route.params.shisetsu

// const midoku_count = ref(prop.param.midoku_count)

// ユーザーが本来所属する社協の名前
// let shozoku_name = ref(prop.param.shozoku_name)

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし）
let enqete_ok = ref(GlobalData.enqete_flg)

// 今日の日付
let today = new Date()

// 受付〆切日の種別（1:事業単位、2:プログラム単位）
let end_shubetsu = ref(1)
// 受付〆切日時
let end_datetime = ref(new Date(today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+" 23:59:59"))


// 申込み可能回数を利用するかどうか（1:する、2:しない）
let program_shubetsu = ref(2)

// 申込み可能回数
let program_count = ref(5)

let kensu = 0

if(program.length != 0){
  kensu =program[0].all_count
}

const emit = defineEmits(['call'])

// ログイン状態
let login_status = ref(true)

// 表示フラグ
// 分類1（固定）
// 分類2
// プログラム名（固定）
// 施設住所
// 活動内容
// 実施期間
// 活動日数
// 参加条件
// 申込〆切
// 開催地名
// 連絡先
// アクセス方法
let list_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0])

// 社協名
let shakyo_name = "";

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]

// 表示件数
const gyo_count = ref(store.state.gyo_count)

// スマホの時は１ページ目かつ全件（10000）
if (document.getElementById("app").clientWidth < 962) {
  
  current_page.value = 1
  gyo_count.value = 10000
}

// 表示件数を変えたら保持
const gyo_change = ()  => {
  store.state.gyo_count = gyo_count.value

  // 1ページ目に戻す
  top()
}

if (!GlobalData.$User_email) { // ログインしているかチェック
    login_status.value = false
}

const st = ref(1)

let ed = ref(Math.min(parseInt(gyo_count.value), program.length+1))
const tm = computed(() => {
    st.value = 1
    ed.value = Math.min(parseInt(gyo_count.value), program.length+1);
    return Math.ceil(program.length / parseInt(gyo_count.value));
})
//-------- ページネーション -------------------
const top     = ()  => { st.value = 1
                         ed.value = st.value+parseInt(gyo_count.value)-1
                         current_page.value = 1
                         page_change(1)                         
                         emit('call',{ cmd:'page_scroll' }) }
const back    = ()  => { st.value = Math.max(1,st.value-parseInt(gyo_count.value))
                         ed.value = st.value+parseInt(gyo_count.value)-1 
                        let set_page = current_page.value
                        // 現在ページ数から1引いたら0にならない場合はマイナスする
                        if( (set_page-1 ) != 0){
                          set_page = set_page - 1
                        }
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const page    = (i) => { st.value = (i-1)*parseInt(gyo_count.value)+1;
                         ed.value = Math.min(i*parseInt(gyo_count.value), program.length+1);
                         page_change(i)
                         emit('call',{ cmd:'page_scroll' })}
const forward = ()  => { st.value += parseInt(gyo_count.value);

                         let set_page = current_page.value

                         // 加算後の表示件数が全件数を超える場合は減算して戻す
                         if (st.value > program.length) { 
                          st.value -= parseInt(gyo_count.value)
                         }else{
                          // 加算後の表示件数が全件数を超えない場合はページを加算する
                          set_page = set_page + 1
                         }
                         ed.value = Math.min( st.value+parseInt(gyo_count.value)-1, program.length) 
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const last    = ()  => { st.value = Math.max(1,program.length-parseInt(gyo_count.value)+1)
                         ed.value = Math.min(st.value+parseInt(gyo_count.value), program.length) 
                         // 全件数 / 表示件数を切り上げたものが最後のページ
                         page_change(Math.ceil(program.length / parseInt(gyo_count.value)))
                         emit('call',{ cmd:'page_scroll' })}
setTimeout(function(){ page(current_page.value) }, "100");

let page_change = function(page){
  current_page.value = page
  store.state.current_page = page
}

//------------------- 締切日を過ぎていれば赤で表示する
const over = (i) => {


  let today = new Date()
  // 一旦事業単位の受付〆切日を格納
  let check_shimekiri = new Date()

  // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
  if(end_shubetsu.value == 2 && program[i+st.value-1].shimekiri_date){
    let shimekiri = new Date(program[i+st.value-1].shimekiri_date)
      shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      shimekiri = new Date(shimekiri);
      shimekiri.setHours(shimekiri.getHours()-9);
      check_shimekiri = shimekiri
   // check_shimekiri = EuShimekiriSetting(program[i+st.value-1].shimekiri_date)
  }else if(end_shubetsu.value == 1){
      // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
      check_shimekiri = ShimekiriSetting(end_datetime.value)
    
  }else{
    // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は終了
    return false
  }

  if (check_shimekiri >= today) {
      return false
  } else {
      return true
  }
}
//------------------- 体験プログラム詳細表示へ
const shosai = (taiken_id,teiin_flg) => { 
    
    // 親コンポーネントでスクロール位置を保存する
  emit('call',{cmd:'scroll_position'});
  router.push('/'+GlobalData.shakyo+'/'+route.params.shisetsu+'/Shisetsu/detail/'+taiken_id)
  
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  return
  router.push('/'+cityname+'/Taiken/enqete/1') 

}

// 二次元コード（スマホのみ）移動
const codereader = function() {
  router.push('/'+cityname+'/' +facility+'/Shisetsu/Readcode') 
}

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる
    
    if(message_method.value == "enqete_error"){
        // アンケート未回答の場合はアンケート画面へ
        move_enqete()
    }
}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}


//------------------- Googlemap（外部リンク）へ
const googlemap = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

const dist = (e) => {
    alert("dist:"+e.clientX+","+e.clientY+" left,bottom:"+drg.value.left+","+drg.value.clientTop)
}
const home = () => { 
   router.replace('/'+cityname+'/'+facility+'/Shisetsu')
}

const login = function() {
   router.replace('/'+cityname+'/'+facility+'/Shisetsu/ShisetsuMaillogin')
}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}

/* 初期処理 */
let user_taiken_jyokyo = []//ユーザーの体験プログラム申込状況を取得
if (GlobalData.$User_email) { // ログインしているかチェック
    if (GlobalData.user_id) { // ユーザー情報があるかチェック
            
        // ログイン中かつユーザー情報登録済みであればこのユーザーの体験プログラムの実績データを取得
        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
        {
           taikenuser_id: GlobalData.user_id,
           program_kbn:1
        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
          if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
          }else{
              user_taiken_jyokyo = response.data.jisseki

          }
        }).catch(error => {
          
        })
      }
    }else{
      login_status.value = false
    }

    // 表示設定と受付〆切日、社協名を取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
           
              // 表示設定を取得
              list_disp.value = response["data"].program_list_disp.split(',')

              // 社協名を取得
              shakyo_name = response["data"].shakyo_name

              // 受付〆切日の種別を取得
              end_shubetsu.value = response["data"].end_shubetsu

            // 受付〆切日の確認
            if(response["data"].end_date){

              let set_time = " 23:59:59"
              if(response["data"].end_time != "" && response["data"].end_time != null) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());

              end_datetime.value = end_date

            }else{
              // 存在しない場合は今日の23時59分59秒まで

            }

            // 申込み可能回数の確認
            if(response["data"].program_shubetsu == 1){
              program_shubetsu.value = response["data"].program_shubetsu
              program_count.value = response["data"].program_count

            }

            /*
            // ユーザー登録後アンケートの実施状況確認
            if(response["data"].enqete_shubetsu == 1){
              setTimeout(function(){Form_answer_check()},"1000")
            }else{
              enqete_ok.value = 2
            }*/
        })
        .catch(error => {
          
//            alert("社協情報の取得時にエラーが発生しました。"+error)
        })

// checkout機能のチェックのために施設を読み込む
axios.post(GlobalData.$API_URL+"Facility_read", 
    {facility_code:route.params.shisetsu}
    ).then(response => {

      // チェックイン機能の利用  true:利用する、false：利用しない 
      checkin_flg.value = response["data"]["facility_info"].qr_read_flg
})
.catch(error => {
  
//  alert("社協情報の取得時にエラーが発生しました。"+error)
})


  // 参加条件をテキスト化
  function createJokenText(startText, endText) {

    if(!startText) return "小学生～一般"

    const STUDENT_LABEL = {
      '小': '小学生',
      '中': '中学生',
      '高': '高校生',
      '大': '大学生',
      '一般': '一般'
    };

    const SCHOOL_LABEL = {
      '小': '小学',
      '中': '中学',
      '高': '高学',
      '大': '大学'
    };

    const parse = (text) => {
      const [kubun, gradeStr] = text.split(':');
      return { kubun, grade: Number(gradeStr) };
    };
    const start = parse(startText);
    const end = parse(endText);

    // 一般のみ
    if (start.kubun === '一般' && end.kubun === '一般') {
      return '一般';
    }

    // 開始と終了が異なる → 常に「～」
    if (startText !== endText) {
      const startLabel =
        start.grade > 0
          ? `${SCHOOL_LABEL[start.kubun]}${start.grade}年生`
          : STUDENT_LABEL[start.kubun];

      const endLabel =
        end.grade > 0
          ? `${SCHOOL_LABEL[end.kubun]}${end.grade}年生`
          : STUDENT_LABEL[end.kubun];

      return `${startLabel}～${endLabel}`;
    }

    // 同一区分・同一学年
    if (start.grade > 0) {
      return `${SCHOOL_LABEL[start.kubun]}${start.grade}年生`;
    }

    // 同一区分・学年なし
    return STUDENT_LABEL[start.kubun];
  }

  // joken_all_startとjoken_all_endのテキストを分解
  function parseKubunText(text) {
    const [kubun, gradeStr] = text.split(':');
    return {
      kubun,
      grade: Number(gradeStr)
    };
  }
    let jizen_dsp = ref(0)
  // 体験フロー１（事前説明会を先に申込む）の時は、申込める事前説明会があればボタンを表示
  if(GlobalData.$taiken_flow == 1){

        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
                
        let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()

        // 今日以前に締め切った事前説明会は除く
        let search_param = {"shimekiri_date":today_set}
        search_param.choson_code = cityname

        axios.post(GlobalData.$API_URL+"Jizen_get", search_param)
        .then(response => {
            
            let program = response.data.jizen
            let jizen_kensu = 0
            // 締め切られていない事前説明会を取得
            if(program.length != 0){
                for(let i=0;i<program.length;i++){
                //   alert(JSON.stringify(program[i]))
                
                    let today = new Date()


                    let shimekiri = new Date(program[i].shimekiri_date +" 23:59:59")
                    
                    if (shimekiri >= today) {
                        jizen_kensu++
                    }
                }
            }


            // すべての事前説明会が締め切られていたらボタンは表示しない
            if(jizen_kensu == 0){
            }else{
                jizen_dsp.value = 1
            }
        
        })
        .catch(error => {
            
        })
  }

// 申込み・申込み取消の未読チェック
let param = {
    choson_code:cityname,
    facility_code:facility,
    program_kbn:1,
    kubun:'1,2'
}
emit('call',{cmd:'check_moushikomi_message',param:param});

// スマホ用ログアウト
const Smart_logout = () => {
    logout()
}
    
  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}     
    
</script>
<style scoped>
.hov,.hov_over,.hov_over:hover {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color:royalblue;
  cursor: pointer;

}

.list_bunrui {
  font-size: 14px;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}

.midashi_pc {
  min-width:100px;
}
.midashi_sp{
  width:10%;
  min-width:100px;
}

@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
